import React from 'react';
import { IBillingInfo } from '@global/types/types';
import { OrderItemType } from '@global/utils/orderUtils';

export interface BillingInfoFormValuesType {
  CCname: string;
  country: string;
  address1: string;
  address2?: string;
  city: string;
  zip: string;
  state: string;
  phone: string;
}

export const EMPTY_BILLING_FORM_VALUES: BillingInfoFormValuesType = {
  country: '',
  city: '',
  state: '',
  zip: '',
  address1: '',
  address2: '',
  phone: '',
  CCname: '',
};

export enum BillingFormType {
  'BillingForm' = 'BillingForm',
  'ChangeBillingForm' = 'ChangeBillingForm',
  'ChangePaymentForm' = 'ChangePaymentForm',
}

export interface BillingInfoFormProps {
  onSubmit?: (e?: React.BaseSyntheticEvent) => Promise<void>;
  billingInfo: IBillingInfo;

  disabledSubmit?: boolean;
  isLoading: boolean;
  buttonId: string;
  buttonText: string;
  isCartButtonLoading?: boolean;
  isButtonLoading?: boolean;
  buttonCancelText?: string;
  buttonCancelAction?: () => void;
  setIsCartButtonLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  toggleAgreementCheck?: () => void;
  agreementText?: string;
  agreementCheck?: boolean;
  enabledAddressDoctor?: boolean;
  formType: BillingFormType;
  withPaymentForm?: boolean;
  onCountryRestrictedProducts?: (products: OrderItemType[]) => void;
  hiddenForm?: boolean;
  setPaymentErr?: (value: string | null) => void;
  isCountrySelectDisabled?: boolean;
  disableCountryLocaleFallback?: boolean;
  region?: string;
  restrictedCountries?: string[];
  isPhysical?: boolean;
}
